import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/esnext.string.match-all.js";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/esm/setPrototypeOf";
const _excluded = ["transformations", "idAndFormat"],
  _excluded2 = ["w", "h", "f"];
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/esnext.string.match-all.js";
function _wrapRegExp() {
  _wrapRegExp = function (e, r) {
    return new BabelRegExp(e, void 0, r);
  };
  var e = RegExp.prototype,
    r = new WeakMap();
  function BabelRegExp(e, t, p) {
    var o = new RegExp(e, t);
    return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype);
  }
  function buildGroups(e, t) {
    var p = r.get(t);
    return Object.keys(p).reduce(function (r, t) {
      var o = p[t];
      if ("number" == typeof o) r[t] = e[o];else {
        for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++;
        r[t] = e[o[i]];
      }
      return r;
    }, Object.create(null));
  }
  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) {
    var t = e.exec.call(this, r);
    if (t) {
      t.groups = buildGroups(t, this);
      var p = t.indices;
      p && (p.groups = buildGroups(p, this));
    }
    return t;
  }, BabelRegExp.prototype[Symbol.replace] = function (t, p) {
    if ("string" == typeof p) {
      var o = r.get(this);
      return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) {
        var t = o[r];
        return "$" + (Array.isArray(t) ? t.join("$") : t);
      }));
    }
    if ("function" == typeof p) {
      var i = this;
      return e[Symbol.replace].call(this, t, function () {
        var e = arguments;
        return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
      });
    }
    return e[Symbol.replace].call(this, t, p);
  }, _wrapRegExp.apply(this, arguments);
}
import { roundIfNumeric, toUrl } from "../utils.js";
// Thanks Colby!
const cloudinaryRegex = /*#__PURE__*/_wrapRegExp(/https?:\/\/([^\/]+)\/([^\/]+)\/(image|video|raw)\/(upload|fetch|private|authenticated|sprite|facebook|twitter|youtube|vimeo)\/?(s\x2D\x2D[a-zA-Z0-9]+\x2D\x2D)?\/?((?:[^_\/]+_[^,\/]+,?)*)?\/(?:(v\d+)\/)?([^\s]+)$/g, {
  host: 1,
  cloudName: 2,
  assetType: 3,
  deliveryType: 4,
  signature: 5,
  transformations: 6,
  version: 7,
  idAndFormat: 8
});
const parseTransforms = transformations => {
  return transformations ? Object.fromEntries(transformations.split(",").map(t => t.split("_"))) : {};
};
const formatUrl = _ref => {
  let {
    host,
    cloudName,
    assetType,
    deliveryType,
    signature,
    transformations = {},
    version,
    id,
    format
  } = _ref;
  if (format) {
    transformations.f = format;
  }
  const transformString = Object.entries(transformations).map(_ref2 => {
    let [key, value] = _ref2;
    return key + "_" + value;
  }).join(",");
  const pathSegments = [host, cloudName, assetType, deliveryType, signature, transformString, version, id].filter(Boolean).join("/");
  return "https://" + pathSegments;
};
export const parse = imageUrl => {
  const url = toUrl(imageUrl);
  const matches = _toConsumableArray(url.toString().matchAll(cloudinaryRegex));
  if (!matches.length) {
    throw new Error("Invalid Cloudinary URL");
  }
  const group = matches[0].groups || {};
  const {
      transformations: transformString = "",
      idAndFormat
    } = group,
    baseParams = _objectWithoutPropertiesLoose(group, _excluded);
  delete group.idAndFormat;
  const lastDotIndex = idAndFormat.lastIndexOf(".");
  const id = lastDotIndex < 0 ? idAndFormat : idAndFormat.slice(0, lastDotIndex);
  const originalFormat = lastDotIndex < 0 ? undefined : idAndFormat.slice(lastDotIndex + 1);
  const _parseTransforms = parseTransforms(transformString),
    {
      w,
      h,
      f
    } = _parseTransforms,
    transformations = _objectWithoutPropertiesLoose(_parseTransforms, _excluded2);
  const format = f && f !== "auto" ? f : originalFormat;
  const base = formatUrl(Object.assign({}, baseParams, {
    id,
    transformations
  }));
  return {
    base,
    width: Number(w) || undefined,
    height: Number(h) || undefined,
    format,
    cdn: "cloudinary",
    params: Object.assign({}, group, {
      id: group.deliveryType === "fetch" ? idAndFormat : id,
      format,
      transformations
    })
  };
};
export const generate = _ref3 => {
  var _props$transformation;
  let {
    base,
    width,
    height,
    format,
    params
  } = _ref3;
  const parsed = parse(base.toString());
  const props = Object.assign({
    transformations: {}
  }, parsed.params, params, {
    format: format || "auto"
  });
  if (width) {
    props.transformations.w = roundIfNumeric(width).toString();
  }
  if (height) {
    props.transformations.h = roundIfNumeric(height).toString();
  }
  // Default crop to fill without upscaling
  (_props$transformation = props.transformations).c || (_props$transformation.c = "lfill");
  return formatUrl(props);
};
export const transform = _ref4 => {
  var _parsed$params, _parsed$params2;
  let {
    url: originalUrl,
    width,
    height,
    format = "auto"
  } = _ref4;
  const parsed = parse(originalUrl);
  if (!parsed) {
    throw new Error("Invalid Cloudinary URL");
  }
  if (((_parsed$params = parsed.params) === null || _parsed$params === void 0 ? void 0 : _parsed$params.assetType) !== "image") {
    throw new Error("Cloudinary transformer only supports images");
  }
  if ((_parsed$params2 = parsed.params) !== null && _parsed$params2 !== void 0 && _parsed$params2.signature) {
    throw new Error("Cloudinary transformer does not support signed URLs");
  }
  const props = Object.assign({}, parsed, {
    width,
    height,
    format
  });
  return generate(props);
};